export const JURISDICTIONS = ["UK", "EU", "AU", "US"];
export const JURISDICTION_NAMES = {
    UK: "United Kingdom", EU: "European Union", AU: "Australia", US: "United States",
};
export const US_STATES = [
    ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["IL", "Illinois"],
    ["NY", "New York State"], ["NYC", "New York City (hiring)"], ["TX", "Texas"], ["UT", "Utah"],
];
export const ROLE_FACETS = {
    deployer: { builds: false, uses: true, supplies: false },
    in_house: { builds: true, uses: true, supplies: false },
    provider: { builds: true, uses: false, supplies: true },
    in_house_and_provider: { builds: true, uses: true, supplies: true },
};
export const ROLE_OPTIONS = [
    { value: "deployer", short: "Bought in",
        label: "Bought or licensed from a supplier, used by us",
        help: "A vendor built it. You carry deployer duties; the supplier carries provider duties." },
    { value: "in_house", short: "Built and used in-house",
        label: "Built by us, used only by us",
        help: "Built or commissioned under your name and never supplied outside the organisation. You carry both provider and deployer duties." },
    { value: "provider", short: "Built and supplied",
        label: "Built by us, supplied to other organisations (now or previously), not used by us",
        help: "Sold, licensed or offered as a service to third parties. Provider duties, including documentation for your customers, continue while any supplied version is in use." },
    { value: "in_house_and_provider", short: "Built, used and supplied",
        label: "Built by us, used by us, and supplied to other organisations (now or previously)",
        help: "You carry provider, deployer and supplier duties together." },
];
export const SYSTEM_ROLES = ROLE_OPTIONS.map((r) => r.value);
export const STAGES = ["Idea", "Design", "Build", "Pilot", "Live", "Retiring"];
export const FLAG_KEYS = ["personal", "people", "chatbot", "synthetic", "gpai", "fs", "publicBody", "auGov", "usFed", "healthcare", "frontier", "thirdParty"];
export const CONTROL_STATUSES = ["none", "partial", "done", "na"];
//# sourceMappingURL=types.js.map